import { render } from "./TankSurvey.vue?vue&type=template&id=6c0c84d3"
import script from "./TankSurvey.vue?vue&type=script&lang=js"
export * from "./TankSurvey.vue?vue&type=script&lang=js"

import "./TankSurvey.vue?vue&type=style&index=0&id=6c0c84d3&scooped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__